var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinmarketcap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:coinmarketcap",
    clipPath: "url(#clip0_4156_354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7378 14.341C20.3188 14.606 19.8258 14.639 19.4518 14.428C18.9758 14.158 18.7138 13.53 18.7138 12.654V10.036C18.7138 8.772 18.2138 7.872 17.3778 7.629C15.9618 7.216 14.8958 8.949 14.4958 9.601L11.9978 13.651V8.701C11.9698 7.561 11.5998 6.88 10.8978 6.674C10.4318 6.539 9.73676 6.593 9.06076 7.627L3.46376 16.614C2.71543 15.1912 2.32485 13.6076 2.32576 12C2.32576 6.586 6.66476 2.182 11.9978 2.182C17.3298 2.182 21.6678 6.586 21.6678 12C21.6718 12.018 21.6698 12.034 21.6708 12.053C21.7208 13.102 21.3808 13.936 20.7378 14.343V14.341ZM23.8178 12.001L23.8168 11.946C23.7868 5.353 18.4968 0 11.9968 0C5.47976 0 0.176758 5.383 0.176758 12C0.176758 18.616 5.47976 24 11.9968 24C14.9878 24 17.8428 22.863 20.0338 20.8C20.4688 20.39 20.4938 19.7 20.0908 19.259C19.9957 19.1541 19.8806 19.0692 19.7524 19.0094C19.6241 18.9495 19.4851 18.9158 19.3437 18.9103C19.2022 18.9048 19.0611 18.9276 18.9285 18.9774C18.796 19.0271 18.6747 19.1028 18.5718 19.2C16.7959 20.8814 14.4433 21.8183 11.9978 21.818C9.14176 21.818 6.57276 20.555 4.80076 18.55L9.84876 10.445V14.182C9.84876 15.976 10.5448 16.556 11.1288 16.726C11.7128 16.896 12.6048 16.78 13.5418 15.258C14.5398 13.644 15.5668 11.961 16.5648 10.378V12.654C16.5648 14.332 17.2368 15.674 18.4078 16.334C19.4638 16.931 20.7918 16.877 21.8728 16.194C23.1848 15.366 23.8908 13.84 23.8168 12.001H23.8178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4156_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinmarketcap);
export default __webpack_public_path__ + "static/media/coinmarketcap.1984eb4281da9da50fec540bb753bc21.svg";
export { ForwardRef as ReactComponent };